import SquareSVG from '@/assets/svg/answers/square.svg';
import HangerSVG from '@/assets/svg/answers/hanger.svg';
import LightningSVG from '@/assets/svg/answers/lightning.svg';
import ForkSVG from '@/assets/svg/answers/spoon.svg';
import CreamSVG from '@/assets/svg/answers/cream.svg';
import RingSVG from '@/assets/svg/answers/ring.svg';
import PuzzleSVG from '@/assets/svg/answers/puzzle.svg';
import HouseSVG from '@/assets/svg/answers/house.svg';

export const questions = [
    {
        iframeURL: 'XgK8N3r2gAyyIPIXU3Ul',
        adFox: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwn&pr=%random%&ptrc=b',
        link: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwwi&pr=%random%',
        options: [
            {
                svg: <HangerSVG />,
                text: 'Платье',
                id: 'dress',
                correct: true,
            },
            {
                svg: <CreamSVG />,
                text: 'Крем для загара',
                id: 'cream',
                correct: false,
            },
            {
                svg: <HouseSVG />,
                text: 'Ваза для цветов',
                id: 'vase',
                correct: false,
            },
            {
                svg: <HouseSVG />,
                text: 'Гипсокартон',
                id: 'drywall',
                correct: false,
            },
        ],
    },
    {
        iframeURL: 'o2PPYjrZnpzyuBIwU6UG',
        adFox: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwh&pr=%random%&ptrc=b',
        link: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwwm&pr=%random%',
        options: [
            {
                svg: <ForkSVG />,
                text: 'Сковорода',
                id: 'pan',
                correct: true,
            },
            {
                svg: <HangerSVG />,
                text: 'Толстовка',
                id: 'hoodie',
                correct: false,
            },
            {
                svg: <ForkSVG />,
                text: 'Еда с доставкой',
                id: 'delivery',
                correct: false,
            },
            {
                svg: <PuzzleSVG />,
                text: 'Детский набор «Яишенка»',
                id: 'toy',
                correct: false,
            },
        ],
    },
    {
        iframeURL: '9OAAgVNP3z1psdIZUvUB',
        adFox: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwk&pr=%random%&ptrc=b',
        link: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvr&pr=%random%',
        options: [
            {
                svg: <PuzzleSVG />,
                text: 'Пудра единорогов',
                id: 'unicorn',
                correct: false,
            },
            {
                svg: <ForkSVG />,
                text: 'Кружка',
                id: 'cup',
                correct: false,
            },
            {
                svg: <PuzzleSVG />,
                text: 'Уроки лепки',
                id: 'lessons',
                correct: false,
            },
            {
                svg: <PuzzleSVG />,
                text: 'Полимерная глина',
                id: 'clay',
                correct: true,
            },
        ],
    },
    {
        iframeURL: '7OK2V1jk4qONuPIaU8Uq',
        adFox: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwvl&pr=%random%&ptrc=b',
        link: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvt&pr=%random%',
        options: [
            {
                svg: <ForkSVG />,
                text: 'Скороварка',
                id: 'cooker',
                correct: true,
            },
            {
                svg: <HangerSVG />,
                text: 'Походная одежда',
                id: 'clothes',
                correct: true,
            },
            {
                svg: <SquareSVG />,
                text: 'Хороший хромакей',
                id: 'screen',
                correct: false,
            },
            {
                svg: <HouseSVG />,
                text: 'Тапочки',
                id: 'shoes',
                correct: false,
            },
        ],
    },
    {
        iframeURL: 'aj8z2MBgAaOMtzIgUmUn',
        adFox: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwvn&pr=%random%&ptrc=b',
        link: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvv&pr=%random%',
        options: [
            {
                svg: <SquareSVG />,
                text: '«Ока»',
                id: 'oka',
                correct: false,
            },
            {
                svg: <SquareSVG />,
                text: 'Очиститель обивки',
                id: 'cleaner',
                correct: true,
            },
            {
                svg: <SquareSVG />,
                text: 'Губа на бампер',
                id: 'lip',
                correct: true,
            },
            {
                svg: <LightningSVG />,
                text: 'Объектив для камеры',
                id: 'lens',
                correct: false,
            },
        ],
    },
    {
        iframeURL: '9Myyamk7ojv4SdIZUvUB',
        adFox: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwj&pr=%random%&ptrc=b',
        link: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvy&pr=%random%',
        options: [
            {
                svg: <ForkSVG />,
                text: 'Кружка',
                id: 'cup',
                correct: false,
            },
            {
                svg: <LightningSVG />,
                text: 'Смартфон',
                id: 'smartphone',
                correct: false,
            },
            {
                svg: <LightningSVG />,
                text: 'Ноутбук',
                id: 'laptop',
                correct: false,
            },
            {
                svg: <HouseSVG />,
                text: 'Придверный коврик',
                id: 'carpet',
                correct: true,
            },
        ],
    },
    {
        iframeURL: 'ypbXpAvr6r3ZTZIQUZUp',
        adFox: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwvw&pr=%random%&ptrc=b',
        link: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvj&pr=%random%',
        options: [
            {
                svg: <RingSVG />,
                text: 'Чокер ',
                id: 'choker',
                correct: false,
            },
            {
                svg: <RingSVG />,
                text: 'Ожерелье ',
                id: 'necklace',
                correct: true,
            },
            {
                svg: <RingSVG />,
                text: 'Обручальные кольца',
                id: 'rings',
                correct: false,
            },
            {
                svg: <RingSVG />,
                text: 'Браслет ',
                id: 'bracelet',
                correct: true,
            },
        ],
    },
    {
        iframeURL: 'DGVxoBy4dBDASvIxUkUR',
        adFox: 'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwvi&pr=%random%&ptrc=b',
        link: 'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvm&pr=%random%',
        options: [
            {
                svg: <SquareSVG />,
                text: 'Пожарная сигнализация',
                id: 'alarm',
                correct: false,
            },
            {
                svg: <HouseSVG />,
                text: 'Свечи ',
                id: 'candles',
                correct: true,
            },
            {
                svg: <HangerSVG />,
                text: 'Черный топ',
                id: 'clothes',
                correct: true,
            },
            {
                svg: <SquareSVG />,
                text: 'Книга с рецептами',
                id: 'book',
                correct: false,
            },
        ],
    },
];
